import {
    AgencyApproval,
    ChecklistStepType,
    CustomerChecklistStep,
    InvestorRelationship,
    MICompanyRelationship,
    WarehouseRelationship
} from '@api';
import { Paper, Typography } from '@mui/material';
import { CardTable } from '@tsp-ui/core/components';

import AgenciesTableRow from './AgenciesTableRow';
import styles from './DueDiligenceCard.module.scss';
import InsurancesTableRow from './InsurancesTableRow';
import InvestorsTableRow from './InvestorsTableRow';
import WarehousesTableRow from './WarehousesTableRow';


const {
    AGENCY, INSURANCE, INVESTORS, WAREHOUSE, DEFAULT
} = ChecklistStepType;

enum tableDataKeys {
    AGENCY = 'agencies',
    INSURANCE = 'insurances',
    INVESTORS = 'investors',
    WAREHOUSE = 'warehouses',
    DEFAULT = ''
}

const tableHeaders = {
    [AGENCY]: [
        'Agency name',
        'First approval date',
        'Last approval date'
    ],
    [INSURANCE]: [
        'Contact',
        'Insurer name',
        'Policy number',
        'Email address',
        'Phone #'
    ],
    [INVESTORS]: [
        'Company name',
        'Contact name',
        'Email address',
        'Phone #'
    ],
    [WAREHOUSE]: [
        'Contact',
        'Lender name',
        'Line amount',
        'Email address',
        'Phone #'
    ],
    [DEFAULT]: null
};

interface DueDiligenceCardProps {
    item: CustomerChecklistStep;
}

export default function DueDiligenceCard({ item }: DueDiligenceCardProps) {
    const tableDataKey = tableDataKeys[item.type];
    const tableItem = tableDataKey ? item[tableDataKey] : [];
    const headers = tableHeaders[item.type] || [];

    return (
        <Paper
            variant="outlined"
            className={styles.root}
        >
            <Typography className={styles.header}>
                {item.name}
            </Typography>

            <div
                className={styles.flex}
            >
                {tableItem?.length && (
                    <CardTable
                        headers={headers}
                        className={styles.scroll}
                    >
                        {tableItem.map(values => (tableDataKey === tableDataKeys.INVESTORS ? (
                            <InvestorsTableRow
                                key={(values as InvestorRelationship).companyName}
                                values={values as InvestorRelationship}
                            />
                        ) : tableDataKey === tableDataKeys.WAREHOUSE ? (
                            <WarehousesTableRow
                                key={(values as WarehouseRelationship).lenderName}
                                values={values as WarehouseRelationship}
                            />
                        ) : tableDataKey === tableDataKeys.AGENCY ? (
                            <AgenciesTableRow
                                key={(values as AgencyApproval).id}
                                values={values as AgencyApproval}
                            />
                        ) : tableDataKey === tableDataKeys.INSURANCE ? (
                            <InsurancesTableRow
                                key={(values as MICompanyRelationship).policyNumber}
                                values={values as MICompanyRelationship}
                            />
                        ) : null))}
                    </CardTable>
                )}

                {item.documents && (
                    <CardTable
                        headers={[ 'Attached documents' ]}
                        className={styles.documentsTable}
                    >
                        {item.documents?.map(({ name }) => (
                            <tr>
                                <Typography
                                    component="td"
                                    key={name}
                                    padding="4px"
                                    variant="body2"
                                    width="100%"
                                >
                                    {name}
                                </Typography>
                            </tr>
                        ))}
                    </CardTable>
                )}
            </div>

            {item.notes && (
                <div className={styles.fullWidth}>
                    <Typography
                        variant="caption"
                        color="textSecondary"
                    >
                        Notes:
                    </Typography>

                    <Typography
                        variant="body2"
                    >
                        {item.notes}
                    </Typography>
                </div>
            )}
        </Paper>
    );
}
